import { Account } from '~/types/account';
import { Company } from '~/types/company';
import { Institution, InstitutionType } from '~/types/institution';
import { MetaDataCursorPage } from '~/types/jsonapi';
import { User } from './user';

export const ConsentQueryKeys = {
  single: (id: string | null) => ['Consent', 'Single', id || ''],
  company: (companyId?: string, type?: InstitutionType) => ['Consent', 'Company', companyId ?? '', { type }],
  companyRoot: (companyId?: string) => ['Consent', 'Company', companyId ?? ''],
  all: ['Consent'],
};

interface Choice {
  label: string;
  value: string;
}

interface UserDataValidation {
  pattern?: string;
}

export enum ConsentStatus {
  Authorized = 'AUTHORIZED',
  Waiting = 'WAITING',
  Pending = 'PENDING',
  Unauthorized = 'UNAUTHORIZED',
  Disabled = 'DISABLED',
}

export enum UserDataType {
  CHOICE = 'choice',
  DATE = 'date',
  EMAIL = 'email',
  HIDDEN = 'hidden',
  PASSWORD = 'password',
  PHONE = 'phone',
  TEXT = 'text',
  INFO = 'info',
  COUNTRY = 'country',
  CHECKBOX = 'checkbox',
}
export interface UserDataItem {
  key: string;
  name: string;
  value: string;
  required: boolean;
  choices?: Choice[];
  type: UserDataType;
  valid: boolean;
  validation?: UserDataValidation;
  showWithUserInfo: boolean;
}

export interface UserInfo {
  title: string;
  text: string;
  type?: string;
  items: {
    title: string;
    text: string;
    iconUrl?: string;
  }[];
}

export interface Consent {
  authorizedAt?: string | null;
  id: string;
  importedAt?: string | null;
  lastRunAt?: string | null;
  updatedAt: string;
  company?: Company;
  institution: Institution | null;
  accounts: Account[];
  status: ConsentStatus;
  redirectUrl?: string;
  userData: UserDataItem[];
  userInfo?: UserInfo;
  debug: boolean;
  purpose: 'IMPORT' | 'SYNC';
  sourceId?: string | null;
  user?: User;
}

export interface ImportableConsent extends Consent {
  alreadyImported: boolean;
}

export interface ConsentsMeta {
  page: MetaDataCursorPage;
  total: number;
}

export interface CreateConsentRequestAttributes {
  companyId: string;
  forConsent?: Consent['id'];
  institutionId: string;
  purpose?: Consent['purpose'];
}

export enum SwanConsentStatus {
  MISSING_DATA = 'MISSING_DATA',
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  UNAUTHORISED = 'UNAUTHORISED',
  READY = 'READY',
}
